var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSmile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74829 11.6412C6.74829 11.6412 7.95617 13.2517 9.9693 13.2517C11.9824 13.2517 13.1903 11.6412 13.1903 11.6412M12.3851 7.61494H12.3931M7.55354 7.61494H7.5616M12.7877 7.61494C12.7877 7.8373 12.6074 8.01756 12.3851 8.01756C12.1627 8.01756 11.9824 7.8373 11.9824 7.61494C11.9824 7.39257 12.1627 7.21231 12.3851 7.21231C12.6074 7.21231 12.7877 7.39257 12.7877 7.61494ZM7.95617 7.61494C7.95617 7.8373 7.77591 8.01756 7.55354 8.01756C7.33118 8.01756 7.15092 7.8373 7.15092 7.61494C7.15092 7.39257 7.33118 7.21231 7.55354 7.21231C7.77591 7.21231 7.95617 7.39257 7.95617 7.61494Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.6105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2061 2.29291C11.4959 2.08799 10.7454 1.97818 9.96926 1.97818C5.52198 1.97818 1.91675 5.58341 1.91675 10.0307C1.91675 14.478 5.52198 18.0832 9.96926 18.0832C14.4165 18.0832 18.0218 14.478 18.0218 10.0307C18.0218 9.41567 17.9528 8.81675 17.8222 8.24125",
    stroke: "#1A1A1A",
    strokeWidth: 1.6105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4431 3.32032H18.9167M16.6799 1.08351V5.55713",
    stroke: "#1A1A1A",
    strokeWidth: 1.6105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSmile);
export default __webpack_public_path__ + "static/media/face-smile.acb36b836c6366c65fc4db848f969c56.svg";
export { ForwardRef as ReactComponent };